import React from 'react'
import {IoIosArrowForward, IoIosArrowBack} from 'react-icons/io'


const Pagination = () => {

    return (
        <div className="w-full flex justify-center align-center ">
              <div className= "flex w-8/12 mx-auto md:w-4/12 space-x-4 justify-center  ">
                  <div className="rounded-full w-6 h-6 flex justify-center align-center border-2 border-tradr-green cursor-pointer  ">
                      <IoIosArrowBack className="text-tradr-green cursor-pointer self-center" />
             </div>  
             <p className="text-tradr-green cursor-pointer text-sm font-light">
                1
                </p>
                <p className="text-ash cursor-pointer text-sm font-light">
                2
                </p>
                <p className="text-ash cursor-pointer text-sm font-light">
                3
                </p>
                <p className="text-ash cursor-pointer text-sm font-light">
                ....
                </p>
                <p className="text-ash cursor-pointer text-sm font-light">
                7
                </p>
                <div className="rounded-full w-6 h-6 flex justify-center align-center border-2 border-tradr-green cursor-pointer  ">
                      <IoIosArrowForward className="text-tradr-green cursor-pointer self-center" />
             </div>  
             </div>  
        </div>
    )
}

export default Pagination